<template>
    <MainContentSearchable title="Bases de emails" id="bases" v-model="filters" :meta="loading ? {} : bases.meta" @updated="debouncedGetBases">
        <template v-slot:header>
            <h3 class="card-title">Listado de bases de emails</h3>
            <div class="card-tools">
                <Button @click="showModal('add-base')">AÑADIR BASE</Button>
                <AddBase @close="closeModal"/>
            </div>
        </template>

        <template v-slot:content v-if="!loading && bases">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th class="text-center">Opciones</th>
                    </tr>
                </thead>
                <tbody v-if="!loading">
                    <template v-for="(base, index) in bases.data">
                        <tr :key="index">
                            <td>{{ base.nombre }}</td>
                            <td class="text-center">
                                <div :class="'btn-group ' + (expand.indexOf(index) >= 0 ? 'show' : '')">
                                    <Button type="button" class="dropdown-toggle" @click.prevent="expandir(index)">OPCIONES</Button>
                                    <div :class="'dropdown-menu ' + (expand.indexOf(index) >= 0 ? 'show' : '')">
                                        <button class="dropdown-item" @click="showModal('editar-base-' + base.id)">Editar</button>
                                        <button class="dropdown-item" @click="showModal('borrar-base-' + base.id)">Borrar</button>
                                        <router-link :to="{ name: 'back.comunicados.bases.emails.index', params:{ base_id: base.id } }" class="dropdown-item">
                                            Ver emails
                                        </router-link>
                                    </div>
                                </div>
                            </td>
                            <BorrarBase :base="base" @close="closeModal"/>
                            <EditarBase :base="base" @close="closeModal"/>
                        </tr>
                    </template>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="6">
                            <LoaderComponent/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from "@/components/backend/components/MainContentSearchable";
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import AddBase from './modals/AddBase';
    import BorrarBase from './modals/BorrarBase';
    import EditarBase from './modals/EditarBase';

    export default {
        data() {
            return {
                bases: null,
                loading: true,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                    search_for: 'n_abonado',
                    tipo: null
                },
                expand: [],
            }
        },
        created() {
            this.getBases();
            this.debouncedGetBases = _.debounce(this.getBases, 500)
        },
        methods: {
            borrar(id) {
                this.loading = true;

                const params = {
                    filters : {},
                    comunicado_id: id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.borrar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.getEmail();
                }).finally(() => this.loading = false);
            },
            getBases : function() {
                this.loading = true;

                const params = {
                    filters : this.filters
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.bases.index'), params).then(res => {
                    this.bases = res.data;
                }).finally(() => this.loading = false);
            },
            expandir(index) {
                if(this.expand.indexOf(index) >= 0) {
                    this.expand.splice(this.expand.indexOf(index), 1);
                } else {
                    this.expand.push(index);
                }
            },
            setPage(page) {
                this.filters.page = page;
                this.getEmails();
            },
            showModal(modal) {
                this.expand = [];
                this.$modal.show(modal);
            },
            closeModal(modal, borrado) {
                this.$modal.hide(modal);
                if(borrado) {
                    this.getBases();
                }
            },
        },
        components: {
            LoaderComponent, AddBase, BorrarBase, MainContentSearchable, EditarBase
        }
    }
</script>
